"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefocusTrigger = void 0;
var _react = require("react");
var _overlays = require("@cbhq/cds-common/tokens/overlays");
var _browser = require("../utils/browser");
/** Refocuses a pressable that opens a menu after the menu has been opened and then closed */
const useRefocusTrigger = shouldRefocus => {
  const ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //  focuses the element after the menu opens & closes at least once
    if (shouldRefocus && (0, _browser.isBrowser)() && ref.current) {
      var _ref$current$parentNo;
      const focusableElements = (_ref$current$parentNo = ref.current.parentNode) === null || _ref$current$parentNo === void 0 ? void 0 : _ref$current$parentNo.querySelectorAll(_overlays.FOCUSABLE_ELEMENTS);
      if (focusableElements !== null && focusableElements !== void 0 && focusableElements.length && focusableElements[0]) {
        focusableElements[0].focus();
      }
    }
  }, [shouldRefocus, ref]);
  return ref;
};
exports.useRefocusTrigger = useRefocusTrigger;